/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner } from './get-zeus-organization-identity-verifications-for-president200-response-inner-identity-verification-inner-records-inner';

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner {
    /**
     * 犯収法確認書類タイプ、本人確認書類(ワ方式)
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'methodType': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum;
    /**
     * 
     * @type {Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'records'?: Array<GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerRecordsInner>;
    /**
     * 各種検証に紐づくID
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'relatedIdentityVerificationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'state': string;
    /**
     * 参照URL
     * @type {Array<string>}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'verificationReferenceURLs'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInner
     */
    'verificationSourceType': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum = {
    companyVerificationDocument: 'COMPANY_VERIFICATION_DOCUMENT',
    idDocument: 'ID_DOCUMENT',
    idDocumentI: 'ID_DOCUMENT_I',
    idDocumentWa: 'ID_DOCUMENT_WA',
    supplementalDocument: 'SUPPLEMENTAL_DOCUMENT'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerMethodTypeEnum];
export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum = {
    internal: 'INTERNAL',
    pocketSign: 'POCKET_SIGN',
    trustdock: 'TRUSTDOCK'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerIdentityVerificationInnerVerificationSourceTypeEnum];


